module.exports = __webpack_public_path__ + "img/arrows.22a512ae.svg";